export default "__VITE_ASSET__Cd2Iev2F__"